/**
 * Vue mixin to serve as a helper for migration process
 * @name Helper Mixing for migration
 * @returns {object} Importable Vue mixin
 */

export default {
  methods: {
    openInNewWindow(state, params, queryParams) {
      const { href: routeUrl } = this.$router.resolve({ name: state, params })
      const queryParamsStr = new URLSearchParams('')

      if (queryParams) {
        Object.entries(queryParams).forEach(([param, value]) => {
          queryParamsStr.set(param, value)
        })
      }

      window.open(
        queryParamsStr.toString() ? `${routeUrl}?${queryParamsStr}` : routeUrl,
        '_blank',
      )
    },
  },
}
